import { render, staticRenderFns } from "./PageFeaturesFlags.vue?vue&type=template&id=3b8ce5e9&scoped=true&"
import script from "./PageFeaturesFlags.vue?vue&type=script&lang=ts&"
export * from "./PageFeaturesFlags.vue?vue&type=script&lang=ts&"
import style0 from "./PageFeaturesFlags.vue?vue&type=style&index=0&id=3b8ce5e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8ce5e9",
  null
  
)

export default component.exports